import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { Failure } from '@core/failure';
import { combineLatest, Observable, UnaryFunction } from 'rxjs';
import { map } from 'rxjs/operators';

export type Filter = {
  field: string,
  values: string[],
}

export function filter(field: string, values: string[]): Filter {
  return { field: field, values: values }
}

function apply(items: any[], exactMatch: boolean, field: string, values: string[]): any[] {
  if (!items) {
    return [];
  }
  if (!field || values.length < 1) {
    return items;
  }

  const compare = (left: string, right: string): boolean => {
    if (exactMatch) {
      return left === right;
    }

    return left.toLowerCase().includes(right.toLowerCase());
  };

  return items.filter(singleItem =>
    values.find(value => compare(singleItem[field], value)) != null);
}

export function applyFilters<T, E>(
  filters: Observable<Filter>[]): UnaryFunction<Observable<T[] | Failure<E>>, Observable<T[] | Failure<E>>>
{
  function applyFilter(
    filter$: Observable<Filter>): UnaryFunction<Observable<T[] | Failure<E>>, Observable<T[] | Failure<E>>>
  {
    return results$ => combineLatest([results$, filter$])
      .pipe(map(([results, filter]) =>
        results instanceof Failure
          ? results
          : apply(results, true, filter.field, filter.values)))
  }

  return results$ => filters.reduce(
    (filteredResults$, filter$) => filteredResults$.pipe(applyFilter(filter$)),
    results$)
}

@Pipe({
  name: 'filter'
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: any[], exactMatch: boolean, field: string, values: string[]): any[] {
    return apply(items, exactMatch, field, values)
  }
}